import { defineAsyncComponent } from 'vue'
export default {
  private: defineAsyncComponent(() => import("/workspace/Optilink/web-portal-frontend/layouts/private.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("/workspace/Optilink/web-portal-frontend/layouts/public.vue").then(m => m.default || m))
}